module.exports = __webpack_public_path__ + "img/5B4CBC_B59AF2_9B84EB_8F78E4-256px.892dc79f.png";